import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-background border-t border-white/5 text-center" role="contentinfo" data-id="element-145">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-146">
        <div className="mb-8" data-id="element-147">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-148">
            🚿 EL MAESTRO DE LAS MAMPARAS
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-149">
            El sistema N°1 para instaladores y talleres de mamparas de vidrio en
            Argentina.
          </p>
          <p className="text-gray-400" data-id="element-150">
            Sin cristales perdidos, sin reclamos, con ganancia real.
          </p>
        </div>

        <nav aria-label="Contacto y redes sociales" className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-8" data-id="element-151">
          <a href="mailto:soporteoficialfegion@gmail.com" className="hover:text-gold transition-colors" data-id="element-152">
            📧 soporteoficialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-153">
            |
          </span>
          <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-154">
            📲 @fegion1
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-155">
            |
          </span>
          <a href="https://www.fegion.shop" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-156">
            🌐 www.fegion.shop
          </a>
        </nav>

        <div className="border-t border-white/5 pt-8" data-id="element-157">
          <p className="text-gray-500 text-sm mb-6" data-id="element-158">
            © El Maestro de las Mamparas™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-159">
            <p data-id="element-160">🚿 "Desde hoy, tu taller de mamparas tiene sistema."</p>
          </div>
        </div>
      </div>
    </footer>;
}